import type React from 'react';
import { Link, Route } from 'react-router-dom';
import { SettingsLayout } from '../components/settings-layout';
import { DiscordConnectCallbackPage } from '../pages/discord-connect-callback-page';
import { DiscordConnectStartPage } from '../pages/discord-connect-start-page';
import { DiscordGuildSettingsPage } from '../pages/discord-guild-settings-page';
import { TelegramConnectCallbackPage } from '../pages/telegram-connect-callback-page';
import { TelegramSettingsPage } from '../pages/telegram-settings-page';

export {
  DiscordGuildSettingsPage as LegacyDiscordSettingsPage,
  TelegramSettingsPage as LegacyTelegramSettingsPage,
};

export function LegacyConnectPage() {
  return (
    <SettingsLayout current="legacy-connect">
      <div className="flex max-w-sm flex-col gap-2">
        <Link
          to="/settings/integrations/discord"
          className="inline-flex h-9 items-center rounded-md border border-border/70 px-3 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          Discord
        </Link>
        <Link
          to="/workspace-bots/telegram"
          className="inline-flex h-9 items-center rounded-md border border-border/70 px-3 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          Telegram
        </Link>
      </div>
    </SettingsLayout>
  );
}

type LegacyConnectRoutesOptions = {
  requireCompletedOnboarding: (
    element: React.ReactElement
  ) => React.ReactElement;
  RedirectWithSearch: React.ComponentType<{ to: string }>;
};

export function legacyConnectRoutes({
  requireCompletedOnboarding,
  RedirectWithSearch,
}: LegacyConnectRoutesOptions) {
  return (
    <>
      <Route
        path="/workspace-bots/discord"
        element={requireCompletedOnboarding(<DiscordGuildSettingsPage />)}
      />
      <Route
        path="/workspace-bots/telegram"
        element={requireCompletedOnboarding(<TelegramSettingsPage />)}
      />
      <Route
        path="/discord/guilds"
        element={requireCompletedOnboarding(
          <RedirectWithSearch to="/workspace-bots/discord" />
        )}
      />
      <Route
        path="/connect/telegram/callback"
        element={<TelegramConnectCallbackPage />}
      />
      <Route
        path="/connect/discord/start"
        element={<DiscordConnectStartPage />}
      />
      <Route
        path="/connect/discord/callback"
        element={<DiscordConnectCallbackPage />}
      />
    </>
  );
}
